import dayjs from 'dayjs';
import { CreneauType } from '../../app.constants';
import { ChampCompteRendu } from '../compte-rendu/champ-compte-rendu.model';
import { UUID } from '../uuid.model';
import { VacationGardiennage } from '../vacation/vacation-gardiennage.model';
import { Consigne } from './consigne.model';
import { ICreneauInter } from './creneau-inter.interface';
import { ElementParcours } from './element-parcours.model';
import { ISite } from './site.interface';
import { Site } from './site.model';
import { IPrecisionSite } from './precision-site.interface';
import { PrecisionSite } from './precision-site.model';

export class CreneauGardiennage implements ICreneauInter {
  constructor(
    public readonly id: UUID,
    public readonly geolocEnabled: boolean,
    public readonly site: ISite | undefined,
    public readonly debut: dayjs.Dayjs,
    public readonly fin: dayjs.Dayjs,
    public readonly vacation?: VacationGardiennage,
    public readonly consignes: Consigne[] = [],
    public readonly materiel: string[] = [],
    public readonly signatureEnabled = false,
    public readonly champsPersonnalises: ChampCompteRendu[] = [],
    public readonly parcours: ElementParcours[] = [],
    public readonly type = CreneauType.GARDIENNAGE,
    public readonly precisionSite?: IPrecisionSite,
    public readonly clientLibelle?: string,
    public readonly numeroRappeler?: string,
    public readonly ponctuel = false
  ) {}

  public static hydrate(creneau: CreneauGardiennage): CreneauGardiennage {
    return new CreneauGardiennage(
      creneau.id,
      creneau.geolocEnabled,
      creneau.site ? Site.hydrate(creneau.site) : undefined,
      dayjs(creneau.debut),
      dayjs(creneau.fin),
      creneau.vacation ? VacationGardiennage.hydrate(creneau.vacation) : undefined,
      creneau.consignes?.length > 0 ? creneau.consignes.map(Consigne.hydrate) : [],
      Object.assign([], creneau.materiel),
      creneau.signatureEnabled,
      creneau.champsPersonnalises ? creneau.champsPersonnalises.map(ChampCompteRendu.hydrate) : [],
      creneau.parcours,
      creneau.type,
      creneau.precisionSite ? PrecisionSite.hydrate(creneau.precisionSite) : undefined,
      creneau.clientLibelle,
      creneau.numeroRappeler,
      creneau.ponctuel ?? false
    );
  }

  public getSiteLibelle(): string {
    return this.site?.libelle ?? '';
  }
}
